import BaseApi from "../../../services/Api";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";

const ModalAnimalImageInfo = ({
  idAnimalImage, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [image, setImage] = useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [animalId, setAnimalId] = React.useState('');

  const handleClose = () => {
    setShowModal(false);
  }

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/animal_imagem${idAnimalImage ? `/${idAnimalImage}` : ''}`).then(res => {
        let data = res.data;
        setImage(data.image)
        setAnimalId(idAnimalImage);
        setLoading(false);
        setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar este lead ou não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
        requestData();
    } else {
        setAnimalId(idAnimalImage);
        setImage(null);
        setUpdateImage(null);
        setLoading(true);
        setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={"Informações do Animal"}>
          <button
            className={`btn btn-${idAnimalImage ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idAnimalImage ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Informações do Animal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                  <div className="form-group mb-3">
                    <label htmlFor="image">Imagem </label>
                    
                    {idAnimalImage ? (
                      <div className="d-flex justify-content-center align-items-center mt-2">
                        <img
                          src={image instanceof File ? URL.createObjectURL(image) : image}
                          alt="imagem do animal"
                          style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                        />
                      </div>
                    ) : 
                      null
                    }

                    {image && !idAnimalImage && (
                      <div className="d-flex justify-content-center align-items-center mt-2">
                        {image ? <img src={image} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                          : <img src={URL.createObjectURL(image)} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        }
                        </div>
                      )
                    }
                  </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
             
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalAnimalImageInfo;